import { useEffect, useState } from "react";

export const clamp = (value: number, min: number, max: number) =>
  Math.min(Math.max(value, min), max);

/**
 * Returns a scroll progress value from 0 (at top) to 1 (scrolled past `distance`).
 * Updates are rAF-throttled for performance.
 *
 * @param distance scroll Y in pixels at which progress reaches 1
 */
export const useScrollProgress = (distance: number) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let frame = 0;
    const update = () => {
      frame = 0;
      setProgress(clamp(window.scrollY / distance, 0, 1));
    };
    const onScroll = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [distance]);

  return progress;
};
